/*
 * Copyright (c) 2023. Bolmate B.V.
 */
import './style/infoContainer.scss';

import classNames from 'classnames';
import React, {PropsWithChildren, useMemo} from 'react';
import InfoIcon from "../icon/infoIcon";

interface Props {
    iconScale?: number;
    className?: string;
}

export default function InfoContainer(props: PropsWithChildren<Props>) {
    const {children, className, iconScale} = props;
    const [scale, size] = useMemo(() => {
        const scale = iconScale ?? .75;
        const size = 28 * scale;
        return [scale, size];
    }, [iconScale]);
    return (
        <div className={classNames('info-container', className)} style={{height: size}}>
            <InfoIcon scale={scale}/>
            <p className='info-message'>{children}</p>
        </div>
    )
}